
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'tick': {
    width: 20,
    height: 20,
    viewBox: '0 0 23 23',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M0 10.5C0 4.70138 4.70138 0 10.5 0C16.2986 0 21 4.70138 21 10.5C21 16.2986 16.2986 21 10.5 21C4.70138 21 0 16.2986 0 10.5ZM9.75362 15.1086L16.3686 8.49362C16.7108 8.1515 16.7108 7.5985 16.3686 7.25637C16.0265 6.91425 15.4735 6.91425 15.1314 7.25637L9.135 13.2528L6.73225 10.85C6.39012 10.5079 5.83712 10.5079 5.495 10.85C5.15287 11.1921 5.15287 11.7451 5.495 12.0872L8.51637 15.1086C8.68 15.2731 8.90312 15.365 9.135 15.365C9.36687 15.365 9.58912 15.2731 9.75362 15.1086Z" fill="#93A0AE"/>'
  }
})
